import CardDaftarPinjaman from "./CardDaftarPinjaman";

export default function DaftarPinjaman(){
    return (
        <div className='container-alur'>
            <h2 className='text-header p-0'>Daftar Pinjaman</h2>
            <p className='m-0 text-center'>Temukan peluang untuk memberikan pinjaman saat ini juga</p>
            <div className="flex flex-row flex-wrap gap-3 pb-20">
                <CardDaftarPinjaman
                    type='konservatif'
                    title='Pinjaman Karyawan'
                    number='2302-1900-1000-1'
                    amount='9.000.000'
                    percentage='2'
                    tenor='3'
                    progress='60'
                    sisaDana='3.600.000'
                    sisaWaktu='10'
                />
                <CardDaftarPinjaman
                    type='moderat'
                    title='Kasbon'
                    number='2302-1900-1000-2'
                    amount='3.000.000'
                    percentage='2'
                    tenor='1'
                    progress='80'
                    sisaDana='600.000'
                    sisaWaktu='3'
                />
                <CardDaftarPinjaman
                    type='agresif'
                    title='Invoice Financing'
                    number='2302-1900-1000-3'
                    amount='18.000.000'
                    percentage='16'
                    tenor='24'
                    progress='70'
                    sisaDana='5.400.000'
                    sisaWaktu='20'
                />
                <CardDaftarPinjaman
                    title='Developer Financing'
                    number='2302-1900-1000-3'
                    amount='30.000.000'
                    percentage='10'
                    tenor='36'
                    progress='40'
                    sisaDana='18.000.000'
                    sisaWaktu='30'
                />
            </div>
        </div>
    );
}